<template>
  <div class="collection-page py-0">
    <div v-if="getBG" class="bg-fixed-100 collection-bg" :class="getBG"></div>
    <div class="black-box"></div>
    <router-link :to="{ name: 'Home'}" @click.native="$emit('headerClick')">
      <img :src="$root.logo" class="main-logo big relative nobg">
    </router-link>
    <Header></Header>
    <div class="content" v-if="collection">
      <h1 class="font-kristi c-red mt-12 mb-0 title-drop-shadow">{{collection.category}}</h1>
      <!--<v-row justify="center">
        <v-col  cols="3" align="center">
          <h4 :class="{'current': !past}" @click="past = false" class="font-kristi c-red button">Current Collection</h4>
        </v-col>
        <v-col  cols="3" align="center">
          <h4 :class="{'current': past}" @click="past = true" class="font-kristi c-red button">Past Collection</h4>
        </v-col>
      </v-row>-->
      <div class="product-container">
        <div
          v-for="(product, index) in past ? collection.past_products : collection.products"
          :key="'product' + index"
          class="product pa-12"
          @click="onProductClick(product.slug)"
          >
            <img :src="product.coverphoto ? product.photosURLBase + product.coverphoto : product.photosURLBase + product.photos[0]">
            <div class="product-title">
              <div class="red-bg"></div>
              <h5 class="pointer font-kristi">{{product.name}}</h5>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../organisms/Header.vue'

import Viewport from '@monogrid/vue-lib/lib/mixins/Viewport'

import slugify from 'slugify'

export default {
  name: 'Collection',

  mixins: [Viewport],

  components: {
    Header
  },

  data () {
    return {
      collection: null,
      past: false
    }
  },

  mounted () {
    console.log(this.$root.config)
    this.getContent()
  },

  computed: {
    getBG () {
      return this.collection ? this.collection.categoryslug.toLowerCase() : ''
    }
  },
  methods: {
    onProductClick (_slug) {
      const slug = slugify(_slug)
      console.log(slug)
      this.$router.push({
        name: 'Product',
        params: {
          product: slugify(_slug)
        }
      })
    },

    getContent () {
      for (let i = 0; i < this.$root.config.collection.length; i++) {
        const colection = this.$root.config.collection[i]
        if (colection.categoryslug.toLowerCase() === this.$route.params.collection.toLowerCase()) {
          this.collection = colection
        }
      }
    }
  },

  watch: {
    $route () {
      console.log(this.$route.params.collection)
      this.getContent()
    }
  },

  metaInfo: function () {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.collection-bg {
  background-image: url('../assets/img/collections-coats-bg.jpg');

  &.dress,
  &.accessories {
    background-image: url('../assets/img/collections-dress-bg.jpg');
  }

  &.pyjama {
    background-image: url('../assets/img/collections-pyjama-bg.jpg');
  }

  &.knitwear,
  &.couturecrochet {
    background-image: url('../assets/img/collections-knitwear-bg.jpg');
  }

  &.menaccessories {
    background-image: url('../assets/img/collections-men-accessories-bg.jpg');
  }

  &.mencapes {
    background-image: url('../assets/img/collections-men-capes-bg.jpg');
  }

  &.menjackets {
    background-image: url('../assets/img/collections-men-jackets-bg.jpg');
  }

  &.menknitwear {
    background-image: url('../assets/img/collections-men-knitwear-bg.jpg');
  }

  &.menshirts {
    background-image: url('../assets/img/collections-men-shirts-bg.jpg');
  }

  &.menkaftans {
    background-image: url('../assets/img/collections-men-kaftans-bg.jpg');
  }

}

h1,
h4 {
  // text-shadow: 2px 2px 5px rgba(0, 0, 0, 1), 2px 2px 5px rgba(0, 0, 0, 0.8);

  &.button {
    cursor: pointer;
    // background: $c-white;
    display: inline-block;
    padding: 5px;
  }

  &.current {
    text-decoration: underline;
  }
}

.product-container {
  width: 100%;
  text-align: center;
}

.product {
  display: inline-flex;
  width: 33.33%;
  height: fit-content;
  position: relative;
  vertical-align: middle;

  @include breakpoint('xs-only') {
    width: 100%;
  }

  img {
    position: relative;
    width: 100%;
    height: auto;
  }

  .product-title {
    position: absolute;
    top: 70%;
    left: 50%;
    transform-origin: center center;
    transform: rotate(-15deg) translateX(-50%);
    padding: 10px 40px;
    font-size: 18px;
    color: #fff;
  }
}

.content {
  z-index: 1;
  position: relative;
}

h1 {
  text-align: center;
}
</style>
